import React, { useEffect, useState } from 'react'
import { ImmunizationBundle } from '../../../../../types/FHIRTypes/Bundle'
import { Immunization as FHIRImmunization } from '@teschglobal/tg-fhir-react-components/dist/types'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { Immunization } from '@teschglobal/tg-fhir-react-components'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type ImmunizationDetailProps = {
  detailId: string;
}

const ImmunizationDetail: React.FC<ImmunizationDetailProps> = ({ detailId }) => {

  const { patientAccessFhirConfig, handleSelectLocation } = useFhirConfig()

    const {
      data: immunization,
      isFetching,
      isLoading,
      isError
    }: UseQueryResult<FHIRImmunization, Error> =
      useFhirResourceById('Patient Access', detailId || '', 'Immunization')
  
    if (isFetching || isLoading) {
      return <FhirLoader />
    }
  
    if (!immunization || isError) {
      return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
    }
  

  return (
    <div>
      <section>
        <Immunization
          data={immunization}
          fhirApiConfig={patientAccessFhirConfig}
          onSelectLocation={handleSelectLocation}
        />
      </section>
    </div>
  )
}

export default ImmunizationDetail